import { Accordion, AccordionDetails, AccordionSummary, Typography, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqDetails = ({
    question,
    answer,
    removeMargin=false,
    expanded=false
}) => {
    const theme = useTheme();

    return (
        <>
            <Accordion
                elevation={0}
                sx={{
                    width: '100%',
                    mt: {xs: removeMargin ? 0 : 1, md: removeMargin ? 0 : 2},
                    py: {xs: 1, md: 2},
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: 4,
                    '&:before': {
                        display: 'none',
                    }
                }}
                defaultExpanded={expanded}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 16, lg: 20}}
                        textAlign='left'
                        color={theme.palette.text.primary}
                        lineHeight={1.5}
                    >
                        {question}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails>
                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 16}}
                        textAlign='left'
                        lineHeight={{xs: 1.5, md: 2}}
                        color={theme.palette.text.secondary}
                    >
                        {answer}
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default FaqDetails;